'use client'

import Faq from '@/app/faq/_components/Faq'
import { useScrollTracking } from '@/hooks/useScrollTracking'

const FaqPage = () => {
  useScrollTracking()
  
  return <Faq />
}

export default FaqPage
